export const SCROLLABLE_COLUMN = 'scrollableColumn';

export const COLOR_SCHEME = {
  SECONDARY: 'secondary',
  PRIMARY: 'primary'
};

export const MOBILE_MENU_MAX_LENGTH = 4;

export const HEADER_COLOR_SCHEME = {
  SECONDARY: 'secondary',
  PRIMARY: 'primary'
};

export const HEADER_COMPONENTS = {
  NAV_MENU_ITEM: 'NAV_MENU_ITEM'
};

export const USER_BLOCK_NAME_TYPES = {
  LOGIN: 'login',
  FULL_NAME: 'fullName',
  NONE: 'none'
};

export const MOBILE_MENU_TILES_TYPE = {
  LOBBY: 'lobby',
  PROFILE_MENU: 'profile-menu'
};

export const SMARTICO_USER_ERROR_CODE = {
  TERRORIST: 1,
  NOT_VERIFIED: 2,
  PASSPORT_IN_VERIFICATION: 3,
  ADDITIONAL_DOCUMENT_REQUIRED: 4,
  LUDOMAN: 5,
  WITH_LIMIT_GAME_ACTIVITY: 7,
  WITH_LIMIT_MAX_BET: 9, // has to show pop-up
  BONUS_HUNTERS: 10,
  SELF_EXCLUDED: 11,
  WITH_LIMIT_MAX_LOSS: 12
};
